import { icons } from './styles';

const constants = {
  lang: 'lang',
  searchTerm: 'Ntt',
  DEFAULT_LAYOUT: 'LIST',
  SESSION_STORAGE_SCROLL: 'scroll',
  SESSION_STORAGE_NEW_PAGE: 'newPage',
  ZONE: {
    COOKIE_NAME: 'zoneData',
    DEFAULT_ZONE_ID: '13',
    DEFAULT_ZONE_NAME: 'R. Metropolitana',
  },
  STORE_NAMES_FOR_VAS: {
    SODIMAC: 'sodimac',
    TOTTUS: 'tottus',
    LINIO: 'linio',
    TIENDA: 'tienda',
    HOMECENTER: 'homecenter',
    SO_COM: 'so_com',
  },
  X_CHANNEL_IDS_HEADERS_VALUES: {
    WEB: 'WEB',
    MOBILE: 'MOBILE',
    TABLET: 'TABLET',
  },
  HEADER_RESPONSE_MY_ACCOUNT_LABEL: 'actionAccount',
  SESSION_COOKIE_NAME: 'JSESSIONID',
  SEARCH_REDIRECT_STATUS: 'alt',
  REDIRECT_CODE: 307, // IE11 was not able to recognize 302
  DEFAULT_COOKIE_DOMAIN: '.falabella.com',
  SO_COM_PAGE_TITLE: 'Sodimac',
  F_COM_PAGE_TITLE: 'Falabella.com',
  META_SITE: {
    DESCRIPTION: {
      TOTTUS: {
        cl: {
          PDP: 'Encuentra $product_name$ $brand_name$ con grandes ofertas en Tottus $country$. Elige el mejor precio para ti y aprovecha nuestras promociones online. $product_id$',
        },
        pe: {
          PDP: 'Compra online $product_name$ de la marca $brand_name$ en Tottus $country$, haz la mejor elección para ti y aprovecha nuestras ofertas.',
        },
        co: {
          PDP: 'Encuentra $product_name$ $brand_name$ con grandes ofertas en Tottus $country$. Elige el mejor precio para ti y aprovecha nuestras promociones online. $product_id$',
        },
        ar: {
          PDP: 'Encuentra $product_name$ $brand_name$ con grandes ofertas en Tottus $country$. Elige el mejor precio para ti y aprovecha nuestras promociones online. $product_id$',
        },
        mx: {
          PDP: 'Encuentra $product_name$ $brand_name$ con grandes ofertas en Tottus $country$. Elige el mejor precio para ti y aprovecha nuestras promociones online. $product_id$',
        },
      },
      SODIMAC: {
        cl: {
          PDP: 'Compra $product_name$ de Sodimac en Falabella.com. Descubre sus características principales y adquiere la mejor opción para ti.',
        },
        pe: {
          PDP: 'Compra a un costo accesible $product_name$, ingresa a nuestro sitio web y conoce más detalles de este producto disponible.',
        },
        co: {
          PDP: 'Compra online $product_name$ en Sodimac $country$ los mejores productos de $brand_name$',
        },
        ar: {
          PDP: 'Compra online $product_name$ en Sodimac $country$ los mejores productos de $brand_name$',
        },
        mx: {
          PDP: 'Compra online $product_name$ en Sodimac $country$ los mejores productos de $brand_name$',
        },
      },
      HOMECENTER: {
        co: {
          PDP: 'Compra online $product_name$ en Homecenter $country$ los mejores productos de $brand_name$',
        },
        mx: {
          PDP: 'Compra online $product_name$ en Homecenter $country$ los mejores productos de $brand_name$',
        },
      },
      LINIO: {
        cl: {
          PDP: '$product_id$',
        },
        pe: {
          PDP: 'Compra online $product_name$ de $brand_name$ en falabella.com conoce sus características y adquiere la mejor opción para ti.',
        },
        co: {
          PDP: '$product_id$',
        },
        ar: {
          PDP: '$product_id$',
        },
        mx: {
          PDP: '$product_id$',
        },
      },
      TIENDA: {
        cl: {
          PDP: '$brand_name$/$product_name$: Revisa sus características y modelos disponibles. Compra online aquí.',
        },
        pe: {
          PDP: 'Compra online $product_name$ de $brand_name$ en falabella.com conoce sus características y adquiere la mejor opción para ti.',
        },
        co: {
          PDP: '$brand_name$/$product_name$: Revisa sus características y modelos disponibles. Compra online aquí.',
        },
        ar: {
          PDP: '$brand_name$/$product_name$: Revisa sus características y modelos disponibles. Compra online aquí.',
        },
        mx: {
          PDP: '$brand_name$/$product_name$: Revisa sus características y modelos disponibles. Compra online aquí.',
        },
      },
      SO_COM: {
        cl: {
          PDP: 'Compra online $product_name$ en Sodimac – Homecenter los mejores productos y la mejor calidad de $category$ $brand_name$',
        },
        pe: {
          PDP: '$product_name$ a un precio increíble de venta exclusiva y de calidad en Sodimac Perú. Compra online $product_name$ y elige entre delivery y retiro en tienda. El stock es limitado.',
        },
        mx: {
          PDP: '$product_name$ a un precio increíble de venta exclusiva y de calidad en Sodimac México. Compra online $product_name$ y elige entre delivery y retiro en tienda. El stock es limitado.',
        },
      },
      TO_COM: {
        cl: {
          PDP: 'Encuentra $product_name$ $brand_name$ con grandes ofertas en Tottus Chile. Elige el mejor precio para ti y aprovecha nuestras promociones online.',
        },
        pe: {
          PDP: 'Encuentra $product_name$ $brand_name$ con grandes ofertas en Tottus Peru. Elige el mejor precio para ti y aprovecha nuestras promociones online.',
        },
      },
      SO_RETAIL: {
        mx: {
          PDP: '$product_name$ a un precio increíble de venta exclusiva y de calidad en Sodimac México. Compra online $product_name$ y elige entre delivery y retiro en tienda. El stock es limitado.',
        },
      },
    },
    TITLE: {
      TOTTUS: {
        cl: {
          PDP: '$product_name$ | Tottus $country$',
        },
        pe: {
          PDP: '$product_name$ | Tottus $country$',
        },
        co: {
          PDP: '$product_name$ | Tottus $country$',
        },
        ar: {
          PDP: '$product_name$ | Tottus $country$',
        },
        mx: {
          PDP: '$product_name$ | Tottus $country$',
        },
      },
      SODIMAC: {
        cl: {
          PDP: '$product_name$ | Sodimac - Falabella',
        },
        pe: {
          PDP: '$product_name$ | Sodimac Falabella',
        },
        co: {
          PDP: '$product_name$ | Sodimac',
        },
        ar: {
          PDP: '$product_name$ | Sodimac',
        },
        mx: {
          PDP: '$product_name$ | Sodimac',
        },
      },
      SO_COM: {
        cl: {
          PDP: '$product_name$ | Sodimac $country$',
        },
        pe: {
          PDP: '$product_name$ | Sodimac $country$',
        },
        co: {
          PDP: '$product_name$ | Sodimac',
        },
        ar: {
          PDP: '$product_name$ | Sodimac',
        },
      },
      SO_RETAIL: {
        mx: {
          PDP: '$product_name$ | Sodimac',
        },
      },
      TO_COM: {
        cl: {
          PDP: '$product_name$ | Tottus $country$',
        },
        pe: {
          PDP: '$product_name$ | Tottus $country$',
        },
      },

      HOMECENTER: {
        co: {
          PDP: '$product_name$ | Homecenter',
        },
      },
      LINIO: {
        cl: {
          PDP: '$product_name$ $brand_name$ | Linio $country$',
        },
        pe: {
          PDP: '$product_name$ $brand_name$ | falabella.com',
        },
        co: {
          PDP: '$product_name$ $brand_name$ | Linio $country$',
        },
        ar: {
          PDP: '$product_name$ $brand_name$ | Linio $country$',
        },
      },
      TIENDA: {
        cl: {
          PDP: '$brand_name$/$product_name$ | Tienda Falabella',
        },
        pe: {
          PDP: '$product_name$ $brand_name$ | falabella.com',
        },
        co: {
          PDP: '$brand_name$/$product_name$ | Tienda Falabella',
        },
        ar: {
          PDP: '$brand_name$/$product_name$ | Tienda Falabella',
        },
        mx: {
          PDP: '$brand_name$/$product_name$ | Tienda Falabella',
        },
      },
    },
  },
  META: {
    DESCRIPTION: {
      cl: {
        PDP: 'Compra $product_name$ de $brand_name$ en Falabella $country$. Descubre sus características principales y adquiere la mejor opción para ti.',
        PLANS:
          'Llévate el celular $brand_name$ $product_name$ que más te guste con el plan perfecto para ti. Encuéntralo en Falabella $country$.',
      },
      pe: {
        PDP: 'Compra online $product_name$ de $brand_name$ en falabella.com conoce sus características y adquiere la mejor opción para ti.',
        PLANS: 'Elige el celular $brand_name$ $product_name$ con increíbles descuentos. Encuétralo en falabella.com',
      },
      co: {
        PDP: 'Compra $product_name$ de $brand_name$ en Falabella $country$. Descubre sus características principales y adquiere la mejor opción para ti.',
        PLANS:
          'Llévate el celular $brand_name$ $product_name$ que más te guste con el plan perfecto para ti. Encuéntralo en Falabella $country$.',
      },
      mx: {
        PDP: 'Compra $product_name$ de $brand_name$ en Falabella $country$. Descubre sus características principales y adquiere la mejor opción para ti.',
        PLANS:
          'Llévate el celular $brand_name$ $product_name$ que más te guste con el plan perfecto para ti. Encuéntralo en Falabella $country$.',
      },
    },
    OG: {
      cl: {
        COUNTRY: 'CL',
        SITENAME: 'Falabella',
        TITLE: 'falabella.com',
        IMAGE: 'https://www.falabella.com/android-chrome-256x256.png',
        IMAGE_MKP: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt82dfb1aadb87635c/OG_Fcom.jpg',
        so_com: {
          COUNTRY: 'CL',
          SITENAME: 'Sodimac',
          TITLE: 'sodimac.com',
        },
        to_com: {
          COUNTRY: 'CL',
          SITENAME: 'Tottus',
          TITLE: 'tottus.cl',
        },
      },
      co: {
        COUNTRY: 'CO',
        SITENAME: 'FalabellaCO',
        TITLE: 'falabella.com',
        IMAGE: 'https://www.falabella.com/android-chrome-256x256.png',
        IMAGE_MKP: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt82dfb1aadb87635c/OG_Fcom.jpg',
      },
      ar: {
        COUNTRY: 'AR',
        SITENAME: 'FalabellaAR',
        TITLE: 'falabella.com',
        IMAGE: 'https://www.falabella.com/android-chrome-256x256.png',
        IMAGE_MKP: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt82dfb1aadb87635c/OG_Fcom.jpg',
      },
      pe: {
        COUNTRY: 'PE',
        SITENAME: 'FalabellaPE',
        TITLE: 'falabella.com',
        IMAGE: 'https://www.falabella.com/android-chrome-256x256.png',
        IMAGE_MKP: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt82dfb1aadb87635c/OG_Fcom.jpg',
        so_com: {
          COUNTRY: 'PE',
          SITENAME: 'Sodimac',
          TITLE: 'sodimac.com',
        },
        to_com: {
          COUNTRY: 'PE',
          SITENAME: 'Tottus',
          TITLE: 'tottus.com.pe',
        },
      },
      mx: {
        COUNTRY: 'MX',
        SITENAME: 'Sodimac',
        TITLE: 'sodimac.com.mx',
        IMAGE: 'https://www.falabella.com/android-chrome-256x256.png',
        IMAGE_MKP: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt82dfb1aadb87635c/OG_Fcom.jpg',
        so_retail: {
          COUNTRY: 'MX',
          SITENAME: 'Sodimac',
          TITLE: 'sodimac.com.mx',
        },
      },
    },
    ORGANISATION: {
      so_com: 'Sodimac',
      to_com: 'Tottus',
    },
  },
  PDP: {
    META: {
      CO: {
        TITLE: '$product_name$ $brand_name$ | falabella.com',
        DESCRIPTION:
          'Encuentra $product_name$ $brand_name$ a precios espectaculares, elige el modelo perfecto para ti y aprovecha nuestras ofertas online.',
      },
    },
  },
  COUNTRY: {
    cl: 'Chile',
    pe: 'Perú',
    co: 'Colombia',
    ar: 'Argentina',
    mx: 'Mexico',
  },
  PAGE_TITLE: {
    cl: 'falabella.com - Mejor Compra Online',
    co: 'falabella.com - Bienvenidos a Nuestra Tienda Online',
    ar: 'Falabella Argentina',
    pe: 'falabella.com - Bienvenidos a Nuestra Tienda Online',
    mx: 'sodimac.com.mx - Bienvenidos a Nuestra Tienda Online',
  },
  TRACING_HEADERS: [
    'x-request-id',
    'x-b3-traceid',
    'x-b3-spanid',
    'x-b3-parentspanid',
    'x-b3-sampled',
    'x-b3-flags',
    'x-ot-span-context',
    'referer',
  ],
  ERROR_MESSAGE_TEXT: 'Product Search Failed',
  DEFAULT_LAYOUT_TYPE: 'HARDLINE',
  PRODUCT_CONSTANTS: {
    HARDLINE: 'HARDLINE',
    SOFTLINE: 'SOFTLINE',
    CONNECT: 'CONNECT',
  },
  HTTP_RES_CODE: {
    FOUND: 302,
    TEMP_REDIRECT: 307,
    PERM_REDIRECT: 301,
    NOT_FOUND_CODE: 404,
  },
  DEVICE_DESKTOP: 'desktop',
  DEVICE_MOBILE: 'mobile',
  DEVICE_TABLET: 'tablet',
  PLATFORM_TYPE: {
    ANDROID: 'android',
    IOS: 'ios',
  },
  LAYOUT_2_GRID: '2_GRID',
  LAYOUT_3_GRID: '3_GRID',
  LAYOUT_4_GRID: '4_GRID',
  LAYOUT_1_GRID: '1_GRID',
  LAYOUT_LIST: 'LIST',
  SPANISH_DAYS_OF_WEEK: {
    1: 'Lun',
    2: 'Mar',
    3: 'Mié',
    4: 'Jue',
    5: 'Vie',
    6: 'Sáb',
    0: 'Dom',
  },
  SPANISH_MONTHS_MAPPER: {
    0: 'Enero',
    1: 'Febrero',
    2: 'Marzo',
    3: 'Abril',
    4: 'Mayo',
    5: 'Junio',
    6: 'Julio',
    7: 'Agosto',
    8: 'Septiembre',
    9: 'Octubre',
    10: 'Noviembre',
    11: 'Diciembre',
  },
  SPANISH_MONTHS_MAPPING: {
    LUN: 'Lun',
    MAR: 'Mar',
    MIE: 'Mié',
    JUE: 'Jue',
    VIE: 'Vie',
    SAB: 'Sáb',
    DOM: 'Dom',
  },
  AVAILABILITY_OUTOFSTOCK: 'OutOfStock',
  AVAILABILITY_INSTOCK: 'InStock',
  AVAILABILITY_HOMEDELIVERY: 'HomeDelivery',
  AVAILABILITY_EXPRESS: 'Express',
  AVAILABILITY_PICKUPINSTORE: 'PickupInStore',
  AVAILABILITY_STOCKINSTORE: 'StockInStore',
  AVAILABILITY_PURCHASEONLINE: 'PurchaseOnline',
  AVAILABILITY_NETWORKSTOCK: 'Network',
  AVAILABILITY_ICON_CLASS_MAPPER: {
    HomeDelivery: 'deliveryAvailable',
    PickupInStore: 'pickupInStoreAvailable',
    StockInStore: 'see-stores',
    PurchaseOnline: 'purchaseOnlineAvailable',
  },
  PRODUCT_TYPE: {
    SOFT_GOOD: 'SOFT_GOOD',
    GIFTCARD: 'GIFTCARD',
  },
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  NOT_FOUND: 'NOT_FOUND',
  DEFAULT_CMR_INSTALLMENTS: 10,
  DEFAULT_CMR_BANK_NAME: 'unselected',
  DEFAULT_CMR_BANK_NAME_AR: 'CMR',
  PAGES: {
    PDP: 'PDP',
    PLP: 'PLP',
    SLP: 'SLP',
    PLANS: 'PLANS',
    CART: 'CART',
    POD: 'POD',
  },
  APP_COMP_ERR_PAGES: {
    'falabella-cl': 'https://www.falabella.com/error/404.html',
    'falabella-pe': 'https://www.falabella.com.pe/falabella-pe/error/404.html',
    'falabella-co': 'https://www.falabella.com.co/falabella-co/error/404.html',
  },
  YOUTUBE_THUMBNAIL_URL: 'https://img.youtube.com/vi/{id}/hqdefault.jpg',
  VIEW_TEMPLATE: {
    TYPE_A: 'TYPE_A',
  },
  DIGITAL_DATA_STORAGE_NAME: 'analyticsInfo',
  WARRANTY_OPTIONS_MIN_ITEM_COUNT_FOR_DROPDOWN: 5,
  CURRENCY: {
    CL: 'CLP',
    CO: 'COP',
    AR: 'ARS',
    PE: 'PEN',
    MX: 'MXN',
  },
  MAX_CART_PRODUCT: 999,
  CONNECT_SPECIFICATIONS: [
    { specId: 'camera', value: 'Cámara principal', text: 'Cámara Trasera' },
    { specId: 'camera', value: 'Cámara frontal', text: 'Cámara Frontal' },
    { specId: 'memory', value: 'Memoria interna', text: 'Memoria Interna' },
    { specId: 'battery', value: 'Capacidad batería (mAh)', text: 'Batería' },
    { specId: 'core', value: 'Velocidad del procesador', text: 'Procesador' },
  ],
  CONNECT_SPECIFICATIONS_PRIORITY: [
    {
      specId: 'camera',
      text: ['Cámara posterior', 'Cámara frontal'],
      label: ['Cámara Trasera', 'Cámara Frontal'],
    },
    { specId: 'memory', text: 'Memoria interna', label: 'Memoria Interna' },
    { specId: 'battery', text: 'Capacidad batería (mAh)', label: 'Batería' },
    { specId: 'core', text: 'Velocidad del procesador', label: 'Procesador' },
    {
      specId: 'screen-size',
      text: 'Tamaño de la pantalla',
      label: 'Tamaño de la pantalla',
    },
    { specId: 'os', text: 'Sistema operativo', label: 'Sistema operativo' },
    {
      specId: 'water-proof',
      text: 'Resistente al agua',
      label: 'Resistencia al agua',
    },
    {
      specId: 'core',
      text: 'Núcleos del procesador',
      label: 'Núcleos del procesador',
    },
    {
      specId: 'memory',
      text: 'Memoria externa incluida',
      label: 'Memoria externa incluida',
    },
    { specId: 'camera', text: 'Flash frontal', label: 'Flash frontal' },
    { specId: 'screen', text: 'Tipo de pantalla', label: 'Tipo de pantalla' },
    {
      specId: 'core',
      text: 'Marca y modelo del procesador',
      label: 'Marca y modelo del procesador',
    },
    { specId: 'memory', text: 'Memoria RAM', label: 'Memoria RAM' },
    {
      specId: 'memory',
      text: 'Memoria expandible',
      label: 'Memoria expandible',
    },
    { specId: 'sim', text: 'Dual SIM', label: 'Dual SIM' },
    { specId: 'gps', text: 'GPS integrado', label: 'GPS integrado' },
    { specId: 'connectivity', text: 'Conectividad', label: 'Conectividad' },
    { specId: 'finger', text: 'Lector de huella', label: 'Lector de huella' },
    { specId: 'made-in', text: 'Hecho en', label: 'Hecho en' },
    { specId: 'weight', text: 'Peso', label: 'Peso' },
  ],
  SESSION_CNF_KEY_NAME: 'FA_SESSION_CNF',
  SESSION_CNF_TTL: 10000,
  ADD_TO_CART_WARNING_MSG_LIMIT: 3,
  MODEL_CHARACTERISTICS_SPECIFICATION_ID: ['Medidas del modelo', 'Medidas de la modelo'],
  FALABELLA_MARKET_PLACE_ID: 'FALABELLA',
  FALABELLA_REGEX: /^falabella$/i,
  SODIMAC_REGEX: /^sodimac$/i,
  HOMECENTER_REGEX: /^homecenter$/i,
  TOTUS_REGEX: /^tottus$/i,
  TOTTUS_REGEX: /^tottus$/i,
  LINIO_REGEX: /^linio$/i,
  LINIO_TIENDA_REGEX: /(linio|tienda)/,
  FIRST_PARTY_SELLER_REGEX: /(tottus|sodimac|linio|falabella|homecenter)/,
  FREE_PICKUP_PRICE: /^\$0$|^S\/0\.00$/,
  NEXT_DAY_DELIVERY_REGEX: /(Llega mañana)/,
  SAME_DAY_HD_CC_REGEX: /(Llega hoy|Retira hoy)/,
  SHIPPING_CC_REGEX: /(Retira hoy|Retira mañana)/,
  STORE_PLACEHOLDER: '{{tienda}}',
  STORES: {
    sodimac: 'sodimac',
    tottus: 'tottus',
    linio: 'linio',
    tienda: 'tienda',
    homecenter: 'homecenter',
    so_com: 'so_com',
    to_com: 'to_com',
    so_retail: 'so_retail',
  },
  DECIMAL_SEPARATOR: {
    cl: ',',
    co: ',',
    ar: ',',
    pe: '.',
    mx: '.',
  },
  DOT_SEPARATOR: {
    cl: '.',
    co: '.',
    ar: '.',
    pe: ',',
    mx: ',',
  },
  GTM_ID: {
    beta: {
      cl: 'GTM-NJX6QWJ',
      ar: 'GTM-K53B7WT',
      pe: 'GTM-T29WRLG',
      co: 'GTM-PQRB5NV',
      mx: '',
      sodimac: {
        cl: 'GTM-WGGFJP',
        pe: 'GTM-5M8VN5',
        co: 'GTM-PQRB5NV',
        mx: '',
      },
    },
    www: {
      cl: 'GTM-NJX6QWJ',
      ar: 'GTM-K53B7WT',
      pe: 'GTM-T29WRLG',
      co: 'GTM-PQRB5NV',
      mx: '',
      sodimac: {
        cl: 'GTM-WGGFJP',
        pe: 'GTM-5M8VN5',
        co: 'GTM-PQRB5NV',
        mx: '',
      },
    },
    staging: {
      cl: 'GTM-NJX6QWJ',
      ar: 'GTM-K53B7WT',
      pe: 'GTM-T29WRLG',
      co: 'GTM-PQRB5NV',
      mx: '',
      sodimac: {
        cl: 'GTM-WGGFJP',
        pe: 'GTM-5M8VN5',
        co: 'GTM-PQRB5NV',
        mx: '',
      },
    },
  },
  GTM_BASE: 'https://www.googletagmanager.com',
  MEDALLIA: 'https://resources.digital-cloud.medallia.com/wdcus/55961/onsite/embed.js',
  GOOGLE_MAP: 'https://maps.googleapis.com/maps/api/js?',
  DIGITAL_DATA_MANAGER_PDP_SCRIPT: {
    dev: 'https://assets-staging.falabella.com/v3/assets/blt07d653b53a07a055/blte2189fa43abf355b/pdp.cjs',
    staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt9dc4ff987f3c1540/pdp.cjs',
    beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3fa4d6f2031ea63e/pdp.cjs',
    www: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt19c4fcb2d0d5ff0a/pdp.cjs',
  },
  DIGITAL_DATA_MANAGER_NO_RESULT_SCRIPT: {
    dev: 'https://assets-staging.falabella.com/v3/assets/blt07d653b53a07a055/blt5bfd70100db5c053/noResult.cjs',
    staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta2518e2baacf2b83/noResult.cjs',
    beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltb3b1a8fe31edced4/noResult.cjs',
    www: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc1b0c6ffbc670416/noResult.cjs',
  },
  guidedSellingColors: {
    amarillo: '#eec12b',
    azul: '#0736c4',
    blanco: '#ffffff',
    burdeo: '#440000',
    cafe: '#8e5b3e',
    gris: '#c6b8b8',
    marron: '#8e5b3e',
    morado: '#77337f',
    musgo: '#1c9e43',
    naranja: '#ef992f',
    naranjo: '#ef992f',
    negro: '#000000',
    plomo: '#c6b8b8',
    rojo: '#ce0c0c',
    rosa: '#f276d5',
    rosado: '#f276d5',
    salmon: '#ef992f',
    verde: '#1c9e43',
    violeta: '#d225db',
    sincolor: 'Sin color',
  },
  LS_HOME_DELIVERY_KEY: 'AVAILABILTY_HD',
  LS_STORE_PICKUP_KEY: 'AVAILABILTY_CC',
  COOKIE_HOME_DELIVERY_KEY: 'availabilityHD',
  LEGAL_BANNER: 'isCookieLegalBannerSelected',
  COOKIE_STORE_PICKUP_KEY: 'availabilityCC',
  DEFAULT_ZONES: 'AFZone',
  ANDES_DEF_ZONE: {
    politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
    priceGroupId: '96',
    zones: ['ZL_CERRILOS', 'LOSC', '130617', '13'],
    oldZones: ['LOSC', '130617', '13'],
    name: 'Seleccion ubicacion',
  },
  DEF_ZONE: {
    cl: {
      staging: {
        politicalId: '4856187d-c035-45ac-9f4e-9290b9e9f85f',
        priceGroupId: '96',
        zones: ['ZL_CERRILOS', 'LOSC', '130617', '13'],
        name: 'Seleccion ubicacion',
      },
      production: {
        politicalId: 'test',
        priceGroupId: '96',
        zones: [
          'PCL3651',
          'PCL3887',
          'FALABELLA_FBY_BT_SDD',
          'PCL2829',
          'PCL3505',
          'REVERSE_RM_REDPROPIA',
          'PCL2998',
          'PCL3577',
          'HUB_SALIDA_DIRECTA_RM',
          'PCL2120',
          'PCL3687',
          '13_MAIPU',
          'PCL2830',
          'PCL3099',
          'PCL3661',
          'BX_R13_BASE',
          'PCL226',
          'STARKEN_R13',
          'PCL3041',
          'FBY_RM_M',
          'PCL2380',
          'FEDEX_RM_URB',
          'PCL2520',
          'PCL3128',
          'PCL2511',
          'LOSC',
          'PCL540',
          'PCL1386',
          'PCL3136',
          'PCL109',
          '2020',
          'PCL1186',
          'PCL3414',
          '3045',
          'PCL1486',
          'PCL3882',
          'PCL2890',
          '130617',
          'PCL25',
          'CHILEXPRESS_8',
          'PCL1839',
          'PCL1736',
          'FALABELLA_FBY_SDD',
          'PCL2269',
          'ZL_CERRILLOS',
          'PCL1135',
          'PCL3606',
          'PCL3611',
          'RM',
          'PCL108',
          'PCL94',
          'FBY_BT_SALIDA_DIRECTA',
          'PCL2288',
          'CHILE_INTERNATIONAL',
          'PCL1364',
          '13',
          'PCL861',
          'PCL2792',
        ],
        name: 'Seleccion ubicacion',
      },
      uat: {
        politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
        priceGroupId: '96',
        zones: [
          'PCL3651',
          'PCL3887',
          'FALABELLA_FBY_BT_SDD',
          'PCL2829',
          'PCL3505',
          'REVERSE_RM_REDPROPIA',
          'PCL2998',
          'PCL3577',
          'HUB_SALIDA_DIRECTA_RM',
          'PCL2120',
          'PCL3687',
          '13_MAIPU',
          'PCL2830',
          'PCL3099',
          'PCL3661',
          'BX_R13_BASE',
          'PCL226',
          'STARKEN_R13',
          'PCL3041',
          'FBY_RM_M',
          'PCL2380',
          'FEDEX_RM_URB',
          'PCL2520',
          'PCL3128',
          'PCL2511',
          'LOSC',
          'PCL540',
          'PCL1386',
          'PCL3136',
          'PCL109',
          '2020',
          'PCL1186',
          'PCL3414',
          '3045',
          'PCL1486',
          'PCL3882',
          'PCL2890',
          '130617',
          'PCL25',
          'CHILEXPRESS_8',
          'PCL1839',
          'PCL1736',
          'FALABELLA_FBY_SDD',
          'PCL2269',
          'ZL_CERRILLOS',
          'PCL1135',
          'PCL3606',
          'PCL3611',
          'RM',
          'PCL108',
          'PCL94',
          'FBY_BT_SALIDA_DIRECTA',
          'PCL2288',
          'CHILE_INTERNATIONAL',
          'PCL1364',
          '13',
          'PCL861',
          'PCL2792',
        ],
        name: 'Seleccion ubicacion',
      },
    },
    pe: {
      staging: {
        politicalId: 'c6b7a50c-60f3-4687-91d0-9461d538812a',
        priceGroupId: '2',
        zones: ['150000'],
        name: 'Seleccion ubicacion',
      },
      production: {
        politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
        priceGroupId: '2',
        zones: [
          'PPE3630',
          'IBIS_51',
          'PPE3342',
          'PPE3361',
          'PPE3576',
          'PPE1112',
          'PPE3601',
          '150100',
          'PPE3627',
          'PPE3384',
          'PPE3628',
          '912_LIMA_2',
          'PPE1280',
          '150000',
          'PPE4',
          'PPE3634',
          '912_LIMA_1',
          'PPE1279',
          '150101',
          'PPE344',
          'PPE2485',
          'PPE3059',
          'PPE3629',
          'PPE2492',
          'IMP_2',
          'PPE3331',
          'PPE3357',
          'PPE1091',
          'PERF_TEST',
          'PPE1653',
          'IBIS_99',
          'PPE3578',
          'OLVAA_81',
          'PPE2815',
          'IMP_1',
          'PPE3164',
          '3202',
          'PPE3618',
          'IBIS_110',
          'PPE3659',
          'PPE2918',
          'PPE2681',
          'URBANO_83',
          'PPE2429',
          'PPE3152',
          'PPE3479',
          'PPE3483',
          'PPE3394',
          'PPE2569',
          'LIMA_URB1_DIRECTO',
          'PPE2511',
          'IBIS_19',
          'PPE1382',
        ],
        name: 'Seleccion ubicacion',
      },
      uat: {
        politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
        priceGroupId: '2',
        zones: [
          'PPE3630',
          'IBIS_51',
          'PPE3342',
          'PPE3361',
          'PPE3576',
          'PPE1112',
          'PPE3601',
          '150100',
          'PPE3627',
          'PPE3384',
          'PPE3628',
          '912_LIMA_2',
          'PPE1280',
          '150000',
          'PPE4',
          'PPE3634',
          '912_LIMA_1',
          'PPE1279',
          '150101',
          'PPE344',
          'PPE2485',
          'PPE3059',
          'PPE3629',
          'PPE2492',
          'IMP_2',
          'PPE3331',
          'PPE3357',
          'PPE1091',
          'PERF_TEST',
          'PPE1653',
          'IBIS_99',
          'PPE3578',
          'OLVAA_81',
          'PPE2815',
          'IMP_1',
          'PPE3164',
          '3202',
          'PPE3618',
          'IBIS_110',
          'PPE3659',
          'PPE2918',
          'PPE2681',
          'URBANO_83',
          'PPE2429',
          'PPE3152',
          'PPE3479',
          'PPE3483',
          'PPE3394',
          'PPE2569',
          'LIMA_URB1_DIRECTO',
          'PPE2511',
          'IBIS_19',
          'PPE1382',
        ],
        name: 'Seleccion ubicacion',
      },
    },
    co: {
      staging: {
        politicalId: '59a6aec4-fc51-4f3b-ab5e-62fd7a1076c0',
        priceGroupId: '10',
        zones: ['14'],
        name: 'Seleccion ubicacion',
      },
      production: {
        politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
        priceGroupId: '10',
        zones: [
          'SERVIENTREGA_10',
          'PCO141',
          'PCO871',
          'PCO749',
          'DEPRISA_52',
          'PCO93',
          'PCO739',
          'ENVIA_79',
          'PCO688',
          'PCO791',
          'PCO1075',
          'ENVIA_68',
          'PCO677',
          'PCO1085',
          'PCO915',
          'ENVIA_1',
          'PCO610',
          'PCO802',
          'SERVIENTREGA_55',
          'PCO186',
          'PCO882',
          'ENVIA_47',
          'PCO656',
          'PCO726',
          'PCO1088',
          'DEPRISA_47',
          'PCO88',
          'PCO920',
          'PCO821',
          'PCO710',
          'PCO1029',
          'PCO762',
          'PCO919',
          'PCO1061',
          'SERVIENTREGA_88',
          'PCO219',
          'PCO892',
          'DEPRISA_55',
          'PCO96',
          'SERVIENTREGA_66',
          'PCO197',
          'PCO948',
          'PCO895',
          'PCO907',
          'PCO516',
          'PCO522',
          'SERVIENTREGA_0',
          'PCO31',
          'TCC_86',
          'PCO311',
          '14',
          'PCO14',
          'ENVIA_53',
          'PCO662',
          'PCO797',
          'PCO753',
          'TCC_66',
          'PCO291',
          'PCO944',
          'PCO807',
          'DEPRISA_40',
          'PCO81',
          'PCO775',
          'DEPRISA_23',
          'PCO64',
          'PCO1067',
          'PCO745',
          'PCO938',
          'PCO800',
          'PCO1113',
          'SERVIENTREGA_5',
          'PCO136',
          'DEPRISA_34',
          'PCO75',
          'TCC_3',
          'PCO228',
          'ENVIA_73',
          'PCO682',
          'PCO1028',
          'PCO764',
          'ENVIA_9',
          'PCO618',
          'TCC_9',
          'PCO234',
          'SERVIENTREGA_39',
          'PCO170',
          'PCO1052',
          'PCO781',
          'PCO1081',
          'SERVIENTREGA_45',
          'PCO176',
          'PCO811',
          'DEPRISA_24',
          'PCO65',
          'TCC_24',
          'PCO249',
          'PCO947',
          'PCO714',
          'PCO900',
          'ENVIA_3',
          'PCO612',
          'PCO865',
          'PCO825',
          'DEPRISA_2',
          'PCO43',
          'PCO794',
          'PCO787',
          'COORDINADORA_87',
          'PCO609',
          'PCO763',
          'SERVIENTREGA_17',
          'PCO148',
          'PCO1112',
          'SERVIENTREGA_25',
          'PCO156',
          '99',
          'PCO326',
          'ENVIA_59',
          'PCO668',
          'DEPRISA_13',
          'PCO54',
          'TCC_78',
          'PCO303',
          'TCC_19',
          'PCO244',
          'PCO880',
          'PCO703',
          'SERVIENTREGA_82',
          'PCO213',
          'IBIS_DIRECTO_BO',
          'PCO704',
          'PCO38',
          'PCO778',
          'PCO1064',
          'ENVIA_6',
          'PCO615',
          'PCO1051',
          'PCO32',
        ],
        name: 'Seleccion ubicacion',
      },
      uat: {
        politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
        priceGroupId: '19',
        zones: [
          'SERVIENTREGA_10',
          'PCO141',
          'PCO871',
          'PCO749',
          'DEPRISA_52',
          'PCO93',
          'PCO739',
          'ENVIA_79',
          'PCO688',
          'PCO791',
          'PCO1075',
          'ENVIA_68',
          'PCO677',
          'PCO1085',
          'PCO915',
          'ENVIA_1',
          'PCO610',
          'PCO802',
          'SERVIENTREGA_55',
          'PCO186',
          'PCO882',
          'ENVIA_47',
          'PCO656',
          'PCO726',
          'PCO1088',
          'DEPRISA_47',
          'PCO88',
          'PCO920',
          'PCO821',
          'PCO710',
          'PCO1029',
          'PCO762',
          'PCO919',
          'PCO1061',
          'SERVIENTREGA_88',
          'PCO219',
          'PCO892',
          'DEPRISA_55',
          'PCO96',
          'SERVIENTREGA_66',
          'PCO197',
          'PCO948',
          'PCO895',
          'PCO907',
          'PCO516',
          'PCO522',
          'SERVIENTREGA_0',
          'PCO31',
          'TCC_86',
          'PCO311',
          '14',
          'PCO14',
          'ENVIA_53',
          'PCO662',
          'PCO797',
          'PCO753',
          'TCC_66',
          'PCO291',
          'PCO944',
          'PCO807',
          'DEPRISA_40',
          'PCO81',
          'PCO775',
          'DEPRISA_23',
          'PCO64',
          'PCO1067',
          'PCO745',
          'PCO938',
          'PCO800',
          'PCO1113',
          'SERVIENTREGA_5',
          'PCO136',
          'DEPRISA_34',
          'PCO75',
          'TCC_3',
          'PCO228',
          'ENVIA_73',
          'PCO682',
          'PCO1028',
          'PCO764',
          'ENVIA_9',
          'PCO618',
          'TCC_9',
          'PCO234',
          'SERVIENTREGA_39',
          'PCO170',
          'PCO1052',
          'PCO781',
          'PCO1081',
          'SERVIENTREGA_45',
          'PCO176',
          'PCO811',
          'DEPRISA_24',
          'PCO65',
          'TCC_24',
          'PCO249',
          'PCO947',
          'PCO714',
          'PCO900',
          'ENVIA_3',
          'PCO612',
          'PCO865',
          'PCO825',
          'DEPRISA_2',
          'PCO43',
          'PCO794',
          'PCO787',
          'COORDINADORA_87',
          'PCO609',
          'PCO763',
          'SERVIENTREGA_17',
          'PCO148',
          'PCO1112',
          'SERVIENTREGA_25',
          'PCO156',
          '99',
          'PCO326',
          'ENVIA_59',
          'PCO668',
          'DEPRISA_13',
          'PCO54',
          'TCC_78',
          'PCO303',
          'TCC_19',
          'PCO244',
          'PCO880',
          'PCO703',
          'SERVIENTREGA_82',
          'PCO213',
          'IBIS_DIRECTO_BO',
          'PCO704',
          'PCO38',
          'PCO778',
          'PCO1064',
          'ENVIA_6',
          'PCO615',
          'PCO1051',
          'PCO32',
        ],
        name: 'Seleccion ubicacion',
      },
    },
    mx: {
      staging: {
        politicalId: '',
        priceGroupId: '1010',
        zones: [],
        name: 'Seleccion ubicacion',
      },
      production: {
        politicalId: 'tes',
        priceGroupId: '1010',
        zones: [],
        name: 'Seleccion ubicacion',
      },
      uat: {
        politicalId: '',
        priceGroupId: '1010',
        zones: [],
        name: 'Seleccion ubicacion',
      },
    },
  },
  PLAN_HELP_NUMBER: '600 390 4100',
  STORE_MODAL_REGION_DATA: 'storeModalRegion',
  STORE_AVAILABILITY_MODAL_WIDTH: {
    screen1: 800,
    screen2: 500,
    screen3: 800,
  },
  STORE_AVAILABILITY_MODAL_HEIGHT: {
    screen1: '100%',
    screen2: 531,
    screen3: 575,
  },
  STOCK_CATEGORY_CONFIG: {
    EXACT_UNITS: 'EXACT_UNITS',
    RANGE: 'RANGE',
  },
  ATC_SESSION_EXPIRED_CODE: 'CHECKOUT_INVALID_SESSION',
  CMR_LIST_OPTIONS: {
    cl: [
      {
        title: 'Con tarjeta CMR',
        divideFactor: 200,
        logo: icons.cmrTarjetaIcon,
      },
      {
        title: 'Con Débito Banco Falabella',
        divideFactor: 500,
        logo: icons.bancoIcon,
      },
      {
        title: 'Con Cuenta Fpay',
        divideFactor: 500,
        logo: icons.fpayIcon,
      },
      {
        title: 'Con tarjeta de crédito',
        divideFactor: 750,
        logo: icons.creditoIcon,
      },
      {
        title: 'Con tarjeta de débito',
        divideFactor: 750,
        logo: icons.debitoIcon,
      },
    ],
    co: [
      {
        title: 'Con tarjeta CMR',
        divideFactor: 1000,
        logo: icons.cardIconsFaco.cmr,
      },
      {
        title: 'Con Débito Banco Falabella',
        divideFactor: 2000,
        logo: icons.cardIconsFaco.banco,
      },
      {
        title: 'Con tarjeta de crédito',
        divideFactor: 4000,
        logo: icons.creditoIcon,
      },
      {
        title: 'Con tarjeta de débito',
        divideFactor: 4000,
        logo: icons.debitoIcon,
      },
    ],
    mx: [],
  },
  SPONSORED_PRODUCTS_CAROUSEL_HEADING: 'También podría interesarte',
  SPONSORED_PRODUCTS_CAROUSEL_SUB_HEADING: 'Patrocinado',
  LOGOMAPPINGS: {
    'icons.cmrTarjetaIcon': icons.cmrTarjetaIcon,
    'cons.bancoIcon': icons.bancoIcon,
    'icons.fpayIcon': icons.fpayIcon,
    'icons.creditoIcon': icons.creditoIcon,
    'icons.debitoIcon': icons.debitoIcon,
  },
  PRICE_TYPE: {
    cmr: 'cmrPrice',
    event: 'eventPrice',
    internet: 'internetPrice',
    normal: 'normalPrice',
    ces: 'cesPrice',
    pro: 'PRECIO+PRO',
    bulkPrice: 'BULKPRICE',
  },
  ML_METRICS: {
    LISTWISE_DATA: {
      LIST_WISE: 'LIST_WISE_DATA',
      ALREADY_ADDED: 'Already added in',
      DELETED_FROM: 'Deleted from',
    },
    METRICS_DATA: {
      WITH_ML: 'Product with mis listas',
      WITHOUT_ML: 'Without mis listas',
      ALREADY_ADDED: 'Product already added',
      NOT_ADDED: 'Product not added',
      CLICK_ML: 'Click mis listas',
      NOT_CLICK_ML: 'Not click mis listas',
      CLICK_CREATE_LIST: 'Click crear nueva lista',
      NOT_CLICK_CREATE_LIST: 'Do not click crear nueva lista',
      SAVE_NEW_LIST: 'Guardar nueva lista',
      NOT_SAVE_NEW_LIST: 'Do not save nueva lista',
      SAVE_IN_MYFAVS: 'Save in favoritos',
      DO_NOT_SAVE_MYFAVS: 'Do not save in favoritos ',
      NOT_SAVE_IN_L2: 'Do not save in Ln 2',
      SAVE_IN_L2: 'Save in Ln 2',
      NOT_SAVE_IN_L3: 'Do not save in Ln 3',
      SAVE_IN_L3: 'Save in Ln 3',
      NOT_SAVE_IN_L4: 'Do not save in Ln 4',
      SAVE_IN_L4: 'Save in Ln 4',
      NOT_SAVE_IN_L5: 'Do not save in Ln 5',
      SAVE_IN_L5: 'Save in Ln 5',
    },
  },
  COLOR_SWATCH_METRICS: {
    METRICS_DATA: {
      PURCHASE_COLOR_SWATCH: 'Purchase',
      NOT_PURCHASE_COLOR_SWATCH: 'Not Purchase',
    },
  },
  REACONDITIONED: {
    Nuevo: 'NUEVO',
    'Sin uso con detalle estético': 'REACONDICIONADO',
    'Open Box': 'OPEN BOX',
    'Reacondicionado excelente (A)': 'REACONDICIONADO',
    'Reacondicionado detalle estético (B)': 'REACONDICIONADO',
    'Segunda mano nuevo con etiqueta': 'REACONDICIONADO',
    'Segunda mano como nuevo': 'REACONDICIONADO',
    'Segunda mano con detalles': 'REACONDICIONADO',
  },
  REVIEW_SECTION_HEADING: 'Opiniones de este producto',
  IMAGE_URlS: {
    cl: '{imageDomain}/FalabellaCL/NoImage/public',
    pe: '{imageDomain}/FalabellaPEAndCO/NoImage/public',
    co: '{imageDomain}/FalabellaPEAndCO/NoImage/public',
    mx: '',
    tottus: '{imageDomain}/Tottus/defaultImage/public',
    sodimac: '{imageDomain}/Sodimac/NonAndes/espanol_default/public',
  },
  SODIMAC_STANDALONE_SITE_REGEX: /sodimac\.(cl|com\.pe)/,
  TOTTUS_STANDALONE_SITE_REGEX: /tottus\.(cl|com\.pe)/,
  standAlones: [
    {
      domain: 'sodimac',
      exp: 'so_com',
      regex: /sodimac\.(cl|com\.pe)/,
      name: 'Sodimac',
    },
    {
      domain: 'tottus',
      exp: 'to_com',
      regex: /tottus\.(cl|com\.pe)/,
      name: 'Tottus',
    },
  ],
  sodimacRetails: [
    {
      domain: 'sodimac',
      exp: 'so_retail',
      regex: /sodimac\.com\.(mx)/,
      name: 'Sodimac',
    },
  ],
  PRODUCT: 'product',
  ARTICULO: 'articulo',
  sites: {
    sodimac: 'SODIMAC',
    tottus: 'TOTTUS',
    linio: 'LINIO',
    tienda: 'TIENDA',
    homecenter: 'HOMECENTER',
    so_com: 'SO_COM',
    so_retail: 'SO_RETAIL',
    to_com: 'FAZIL_MKP',
    marketplace: 'FA_MKP',
    fa_america: 'FA_AMERICA',
    fa_carters: 'FA_CARTERS',
    fa_aldo: 'FA_ALDO',
    fa_crabarr: 'FA_CRABARR',
    fa_thedrop: 'FA_THEDROP',
  },
  subdomains: {
    sodimac: 'sodimac',
    tottus: 'tottus',
    homecenter: 'homecenter',
  },
  SposonsoredDisplayPosition: {
    desktop: 4,
    mobile: 5,
  },
  CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
  GENDER_ATTRIBUTE: 'Género',
  IS_USER_OVER_18: 'isUserOver18',
  ALLOWED_PARAMS_REDIRECT: ['orderNumberForReview'],
  whitelabels: [
    {
      domain: 'americanino',
      exp: 'fa_america',
    },
    {
      domain: 'carters',
      exp: 'fa_carters',
    },
    {
      domain: 'aldo',
      exp: 'fa_aldo',
    },
    {
      domain: 'crateandbarrel',
      exp: 'fa_crabarr',
    },
    {
      domain: 'thedropzone',
      exp: 'fa_thedrop',
    },
  ],
  whitelabelBrands: ['americanino', 'carters', 'aldo', 'crateandbarrel', 'thedropzone', 'aldoshoes'],
  CES_BADGE_LABEL: {
    CES_BLACK: 'CES BLACK',
    CES_ORO: 'CES ORO',
    CES_PLATA: 'CES PLATA',
  },
  USER_SEGMENTS: 'userSegments',
  GOOGLE_AD_POSITION: { V1: 'BANNER_V1', V2: 'BANNER_V2', V3: 'BANNER_V3' },
  GOOGLE_ADS: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
  TENANTS: {
    FALABELLA_CL: 'falabella-cl',
    FALABELLA_PE: 'falabella-pe',
    FALABELLA_CO: 'falabella-co',
    SODIMAC_CL: 'sodimac-cl',
    SODIMAC_PE: 'sodimac-pe',
    SODIMAC_CO: 'sodimac-co',
    SODIMAC_MX: 'sodimac-mx',
    HOME_CENTER_CO: 'homecenter-co',
    TOTTUS_CL: 'tottus-cl',
    TOTTUS_PE: 'tottus-pe',
    LINIO_CL: 'linio-cl',
    LINIO_PE: 'linio-pe',
    LINIO_CO: 'linio-co',
  },
  timeZones: {
    cl: 'America/Santiago',
    pe: 'America/Lima',
    co: 'America/Bogota',
    mx: 'America/Mexico_City',
  },
  MONTHS: {
    enero: '01',
    en: '01',
    ene: '01',
    febrero: '02',
    feb: '02',
    marzo: '03',
    mar: '03',
    abril: '04',
    abr: '04',
    mayo: '05',
    may: '05',
    junio: '06',
    jun: '06',
    julio: '07',
    jul: '07',
    agosto: '08',
    ag: '08',
    ago: '08',
    septiembre: '09',
    set: '09',
    sep: '09',
    sept: '09',
    octubre: '10',
    oct: '10',
    noviembre: '11',
    nov: '11',
    diciembre: '12',
    dic: '12',
  },
};

export default constants;
